import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faHouse } from '@fortawesome/free-solid-svg-icons/faHouse';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { DeliveryStatus } from '@api/shipping-data/types/DeliveryStatus';
import OrderIcon from 'components/custom-icon/OrderIcon';
import OrderCancelledIcon from 'components/custom-icon/OrderCancelledIcon';
import OrderChangedIcon from 'components/custom-icon/OrderChangedIcon';
import SmsSendIcon from 'components/custom-icon/SmsSendIcon';



interface CustomerIconsProps {
	deliveryStatus: DeliveryStatus;
	isCancelled: boolean;
	isReduced: boolean;
	smsWasSend: boolean;
}


export const CustomerIcons = (props: CustomerIconsProps) => {
	const { deliveryStatus, isCancelled, isReduced, smsWasSend } = props;


	const getState = () => {
		if (isCancelled) return ' state-danger';
		if (isReduced) return ' state-warning';
		if (deliveryStatus === DeliveryStatus.delivered) return ' state-success';
		return '';
	};

	const getIcon = () => {
		if (deliveryStatus === DeliveryStatus.delivered) return <FontAwesomeIcon icon={faCircleCheck} />
		if (deliveryStatus === DeliveryStatus.truck) return <FontAwesomeIcon icon={faTruck} />;
		if (deliveryStatus === DeliveryStatus.dc) return <FontAwesomeIcon icon={faHouse} />;
		return <OrderIcon />;
	};

	return (
		<p className={`component-customer-icons${getState()}`}>
			{getIcon()}

			{isCancelled && <OrderCancelledIcon />}

			{isReduced && <OrderChangedIcon />}

			{smsWasSend && <SmsSendIcon />}
		</p>
	)
}